/* eslint-disable react/prop-types */
import React, { useEffect, useState, useMemo } from 'react';

import CreateButton from '../../../elements/CreateButton';
import DeleteButton from '../../../elements/DeleteButton';
import EditButton from '../../../elements/EditButton';
import Loader from '../../../elements/Loader';
import Table from '../../../elements/Table';
import ViewButton from '../../../elements/ViewButton';
import Paginator from '../../../elements/paginator';
import axios from '../../../services/MyAxios';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import {
    CASINO_FREESPIN_PAGES_CREATE,
    CASINO_FREESPIN_PAGES_EDIT,
    CASINO_FREESPIN_PAGES_SHOW,
} from '../Helpers/CrmUrls';
import { replaceUrlParams } from '../Helpers/UrlHelper';

function FreespinPagesList() {
    const [bonusPages, setBonusPages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);

    const apiUrl = '/crea/casino/api/freespin-pages';

    const getFreespinPages = (page = 1) => {
        setIsLoading(true);

        let apiUrlWithPagination = apiUrl;

        if (page !== 1) {
            apiUrlWithPagination += `?page=${page}`;
        }

        axios.get(apiUrlWithPagination).then((response) => {
            response.data.data.map((element) => {
                element.details_accessor = { id: element.id, canDelete: element.casino_freespin_campaign_id === null };
                return element;
            });

            setBonusPages(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
        setIsLoading(false);
    };

    useEffect(() => {
        getFreespinPages();
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Title',
                accessor: 'title',
                Cell: ({ value }) => <div>{value}</div>,
            },
            {
                Header: 'Slug',
                accessor: 'url',
                Cell: ({ value }) => (
                    <div>
                        <a href={value} target="_blank" rel="noreferrer">
                            {value}
                        </a>
                    </div>
                ),
            },
            {
                Header: 'Language code',
                accessor: 'language.code',
            },
            {
                Header: 'Image',
                accessor: 'image_path',
                Cell: ({ value }) => <img style={{ maxWidth: '25%' }} src={`${value}`} alt="" />,
            },
            {
                Header: 'Actions',
                accessor: 'details_accessor',
                Cell: ({ value }) => (
                    <div>
                        <ViewButton
                            url={replaceUrlParams(CASINO_FREESPIN_PAGES_SHOW, { id: value.id })}
                            permissions={[CRM_PERMISSION.FREESPIN_PAGE_SHOW]}
                            key="view"
                        />
                        <EditButton
                            url={replaceUrlParams(CASINO_FREESPIN_PAGES_EDIT, { id: value.id })}
                            permissions={[CRM_PERMISSION.FREESPIN_PAGE_EDIT]}
                            key="edit"
                        />
                        {value.canDelete && (
                            <DeleteButton
                                url={`/crea/casino/api/freespin-pages/${value.id}`}
                                action={getFreespinPages}
                                permissions={[CRM_PERMISSION.FREESPIN_PAGE_DELETE]}
                                key="delete"
                            />
                        )}
                    </div>
                ),
            },
        ],
        []
    );

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <span>All freespin pages</span>
                <CreateButton
                    url={CASINO_FREESPIN_PAGES_CREATE}
                    permissions={[CRM_PERMISSION.FREESPIN_PAGE_CREATE]}
                    key="create"
                    buttonText="Create a new freespin page"
                />
            </div>
            <div className="card-body">
                <Loader loading={isLoading} content={() => <Table columns={columns} data={bonusPages} />} />
                <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getFreespinPages} />
            </div>
        </div>
    );
}

export default FreespinPagesList;
